import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const activityService = {
  getAllActivities,
  addActivity,
  getActivity,
  deleteActivity
};

function getAllActivities(params) {
  return apiCall("GET", apiUrls.activities.base, null, params);
}

function addActivity(request, id) {
  const method = id ? "PUT" : "POST";
  let url = apiUrls.activities.base;
  !!id && (url = `${url}/${id}`);
  return apiCall(method, url, request);
}

function getActivity(id) {
  return apiCall("GET", `${apiUrls.activities.base}/${id}`);
}

function deleteActivity(id) {
  return apiCall("DELETE", `${apiUrls.activities.base}/${id}`);
}
